//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminPersonsController_findAll,
  Response$AdminPersonsController_findAll$Status$200,
  ResponseContentType$AdminPersonsController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminPersonsController_findAll = (options: {
  params: Params$AdminPersonsController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminPersonsController_findAll$Status$200[ResponseContentType$AdminPersonsController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminPersonsController_findAll,
    Response$AdminPersonsController_findAll$Status$200[ResponseContentType$AdminPersonsController_findAll]
  >({
    method: 'AdminPersonsController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
